import * as React from 'react';

import axios from 'axios';
import { data } from 'jquery';

export default function Dropzone({childToParent, parentToChild}) {
    const fileInputRef = React.useRef(null);
    const [selectedFiles, setSelectedFiles] = React.useState([]);
    const [validFiles, setValidFiles] = React.useState([]);
    const [uploadedFile, setuploadedFile] = React.useState(parentToChild);

    React.useEffect(() => {
        let filteredArr = selectedFiles.reduce((acc, current) => {
            const x = acc.find(item => item.name === current.name);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
        }, []);
        setValidFiles([...filteredArr]);
    }, [selectedFiles]);

    React.useEffect(() => {
        if (validFiles.length > 0) {
            uploadFiles();
        }
    }, [validFiles]);

    const preventDefault = (e) => {
        e.preventDefault();
    }

    const dragOver = (e) => {
        preventDefault(e);
    }

    const dragEnter = (e) => {
        preventDefault(e);
    }

    const dragLeave = (e) => {
        preventDefault(e);
    }

    const fileDrop = (e) => {
        preventDefault(e);
        const files = e.dataTransfer.files;
        if (files.length) {
            handleFiles(files);
        }
    }

    const filesSelected = () => {
        if (fileInputRef.current.files.length) {
            handleFiles(fileInputRef.current.files);
        }
    }

    const fileInputClicked = () => {
        fileInputRef.current.click();
    }

    const handleFiles = (files) => {
        for(let i = 0; i < files.length; i++) {
            if (validateFile(files[i])) {
                setSelectedFiles(prevArray => [...prevArray, files[i]]);
            } else {
                files[i]['invalid'] = true;
                setSelectedFiles(prevArray => [...prevArray, files[i]]);
            }
        }
    }

    const validateFile = (file) => {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/x-icon'];
        if (validTypes.indexOf(file.type) === -1) {
            return false;
        }

        return true;
    }

    const getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const uploadFiles = async () => {
        for (let i = 0; i < validFiles.length; i++) {
            const formData = new FormData();
            
            getBase64(validFiles[i], (result) => {
                formData.append('data', result);
                formData.append('path', 'site');
                formData.append('key', '');

                axios.post('/api/uploads/img', formData, {
                    onUploadProgress: (progressEvent) => {
                        const uploadPercentage = Math.floor((progressEvent.loaded / progressEvent.total) * 100);

                        if (uploadPercentage === 100) {
                            validFiles.length = 0;
                            setValidFiles([...validFiles]);
                            setSelectedFiles([...validFiles]);
                        }
                    },
                })
                .then(response => {
                    if (response) { 
                        childToParent(response.data.src);
                        setuploadedFile(response.data.src);
                      }                    
                });
            });
        }
    }

    return (
        <div>
            <div>
                <div className="file-drop-container"
                    onDragOver={dragOver}
                    onDragEnter={dragEnter}
                    onDragLeave={dragLeave}
                    onDrop={fileDrop}
                    onClick={fileInputClicked}
                >
                    <div className="drop-message">
                        <p className="dragDropText">Drag & Drop</p>
                        <p><small>or</small></p>
                        <p className="chooseFileText">Choose File</p>
                    </div>
                    {
                        <div className="preview-img">
                            <img src={uploadedFile} alt="" />
                        </div>
                    }

                    <input
                        ref={fileInputRef}
                        className="file-input"
                        type="file"
                        onChange={filesSelected}
                    />
                </div>
            </div>
        </div>
    );
}